
function CookieConsent(content, textPrivacy, urlPrivacy = "#") {

  	const modalId = "cookieConsentModal";
  	const cookieName = "cookie-consent-tracking-allowed";
    var modal;

    const modalContent = '<div class="cookies-infos-wrapper"><div class="cookies-infos-holder"><i class="my-close-modal far fa-times-circle"></i><p>'+ content +' <a href="'+ urlPrivacy +'">'+ textPrivacy +'</a></p></div></div>'
    

    function setCookie(name, value, days) {
        var expires = ""
        if (days) {
            var date = new Date()
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
            expires = "; expires=" + date.toUTCString()
        }
        document.cookie = name + "=" + (value || "") + expires + "; Path=/; SameSite=Strict;"
    }

    function getCookie(name) {
        var nameEQ = name + "="
        var ca = document.cookie.split(';')
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i]
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length)
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length)
            }
        }
        return undefined
    }

    function documentReady(fn) {
        if (document.readyState !== 'loading') {
            fn()
        } else {
            document.addEventListener('DOMContentLoaded', fn)
        }
    }

    function hideDialog() {
        modal.style.display = "none"
    }

    function showDialog() {
        documentReady(function () {
            modal = document.getElementById(modalId)
            if (!modal) {
                modal = document.createElement("div")
                modal.id = modalId
                modal.innerHTML = modalContent
                document.body.append(modal)
                modal.querySelector(".my-close-modal").addEventListener("click", function () {
                    setCookie(cookieName, "true", 365);
                    hideDialog();
                })
            } else {
                modal.style.display = "block"
            }
        })
    }

    if (getCookie(cookieName) === undefined) {
        showDialog()
    }


}